.xm-cp-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  vertical-align: middle;
  width: 28px;
  height: 28px;
  padding: 3px;
  background: var(--ant-color-bg-container);
  border: 1px solid var(--ant-color-border);
  border-radius: var(--ant-border-radius);
  cursor: pointer;
}

.xm-cp-trigger-swatch {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 2px;
}

.xm-color-picker-popup {
  .xm-cp-panel {
    width: 200px;
  }

  .xm-cp-divider {
    margin: 8px 0;
  }

  .ant-color-picker-slider-container > .ant-color-picker-color-block {
    width: 16px;
    height: 16px;
    border-radius: 3px;
  }

  .ant-color-picker-palette,
  .ant-color-picker-handler {
    cursor: crosshair !important;
  }

  .xm-cp-swatches {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .xm-cp-swatch {
    width: 16px;
    height: 16px;
    padding: 0;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.15s ease;

    &:hover,
    &.xm-cp-swatch-active {
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15), 0 0 4px var(--sw);
    }
  }
}
